import { useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';

const clearBrowserCache = async () => {
  // Try to use service worker for cache control
  if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
    try {
      navigator.serviceWorker.controller.postMessage({ action: 'CLEAR_CACHES' });
      console.log('Requested cache clear via service worker');
    } catch (error) {
      console.warn('Failed to clear cache via service worker:', error);
    }
  }
  // Fallback: Clear Cache Storage API
  if ('caches' in window) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map(cacheName => caches.delete(cacheName)));
      console.log('Cache storage cleared');
    } catch (err) {
      console.error('Failed to clear cache storage:', err);
    }
  }
};

const getLatestVersion = async () => {
  try {
    const res = await fetch('/build-metadata.js?_=' + Date.now(), { cache: 'no-store' });
    const text = await res.text();
    // Extract version from the JS file
    const match = text.match(/window\.__BUILD_VERSION__\s*=\s*['\"]([^'\"]+)['\"]/);
    if (match) return match[1];
  } catch (e) {
    console.error('Failed to fetch latest version:', e);
  }
  return null;
};

const UpdateNotifier = () => {
  const intervalRef = useRef();
  useEffect(() => {
    let isMounted = true;
    const checkVersion = async (showToast = false) => {
      const latestVersion = await getLatestVersion();
      if (!latestVersion) return;
      const storedVersion = localStorage.getItem('appVersion');
      if (storedVersion && storedVersion !== latestVersion) {
        toast.success(
          <div>
            <b>New version available!</b>
            <div>
              Current: {storedVersion} <br />
              New: {latestVersion}
            </div>
            <button
              style={{
                marginTop: 8,
                padding: '4px 12px',
                background: '#2563eb',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                cursor: 'pointer'
              }}
              onClick={async () => {
                localStorage.setItem('appVersion', latestVersion);
                await clearBrowserCache();
                window.location.reload(true);
              }}
            >
              Update now
            </button>
          </div>,
          { duration: Infinity, position: 'top-center' }
        );
      } else if (!storedVersion) {
        localStorage.setItem('appVersion', latestVersion);
      } else if (showToast && storedVersion === latestVersion) {
        // Optionally, you could show a 'You are up to date' toast here
      }
    };
    // Initial check (do not show toast on first load)
    checkVersion(false);
    // Poll every 2 minutes
    intervalRef.current = setInterval(() => {
      checkVersion(true);
    }, 2 * 60 * 1000);
    return () => {
      isMounted = false;
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);
  return null;
};

export default UpdateNotifier; 